import { v4 as uuid } from 'uuid'

// in-memory
export const clientRef = uuid()
